import script from "./SupportDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SupportDialog.vue?vue&type=style&index=0&id=2ebff12c&lang=scss"

const __exports__ = script;

export default __exports__